import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@/utils/gtm'
import '@/interceptors/axios'
import { DOTDIGITAL_ENABLED, DOTDIGITAL_TAG_SRC } from '@/config/constants'
import { fetchDomAttribute } from './utils/util.dom'
import { AUTH_SET_CREDENTIAL } from './store/types'

if (DOTDIGITAL_ENABLED) {
  const script = document.createElement('script')
  script.src = DOTDIGITAL_TAG_SRC
  script.async = true
  document.head.appendChild(script)
}

const apiKey = fetchDomAttribute('key')
if (apiKey) {
  localStorage.setItem('apiKey', apiKey)
  store.commit(AUTH_SET_CREDENTIAL, {
    merchant: '',
    customerId: '',
  })
} else {
  localStorage.removeItem('apiKey')
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
